export function createAction(type: string, payload?: object | boolean) {
    return {
      type,
      payload,
    };
  }
  